module.exports = __webpack_public_path__ + "static/media/WorldQuant_Transcript.e77340e2.png";